import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { SocialMediaService, SocialMedia } from './social-media.service';
import { CommonFiltersResolve } from '../filters/common-filters-resolve';
import { ActiveFiltersService } from '../filters/active-filters.service';

@Injectable()
export class SocialMediaResolve extends CommonFiltersResolve implements Resolve<SocialMedia[]> {
	constructor(private service: SocialMediaService,
	            private activeFiltersService: ActiveFiltersService,
	            private mask: LoadingMaskService) {
		super(activeFiltersService);
	}

	resolve(route: ActivatedRouteSnapshot): Promise<SocialMedia[]> {
		this.mask.addLoading();
		let filters: any = this.initActiveFiltersFromURLParams(route);
		return this.service.getSocialMedia(filters)
			.then((socialMedia: SocialMedia[]) => {
				this.mask.removeLoading();
				return socialMedia;
			});
	}
}
